import { jwtDecode as jwt_decode } from "jwt-decode";
import { gmtToIanaMap } from "../static_data";
export const playBeepSound = () => {
  const audio = new Audio("/beep.mp3"); // 🔊 Ensure the file is in `public/beep.mp3`
  audio
    .play()
    .catch((error) => console.error("🔇 Error playing beep sound:", error));
};


export function getFormattedUserTimeZone() {
  let t = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let timeZone = t;

  const token = localStorage.getItem("@token");
  if (token) {
    try {
      const decoded = jwt_decode(token);
      if (decoded?.user_time_zone) {
        timeZone = decoded.user_time_zone;
      }
    } catch (err) {
      console.error("Invalid token:", err);
    }
  }

  const matchedZone = gmtToIanaMap.find(x => x.value === timeZone);

  if (matchedZone) {
    return `Timezone set to ${matchedZone.label}`;
  } else {
    return `Timezone set to ${timeZone}`;
  }
}
